import { useRef } from "react";

import { Container, Row, Col } from "reactstrap";
import { Link, NavLink } from "react-router-dom";
import AutomatRulate from "../../assets/all-images/AutomatRulateBlack.png";
import BT from "../../assets/all-images/BT.png";
import Credius from "../../assets/all-images/Credius.png";
import Mogo from "../../assets/all-images/MOGO.png";
import TBI from "../../assets/all-images/TBI_Bank.png";
import "../../styles/header.css";

const navLinks = [
  { path: "/home", display: "Acasa" },
  { path: "/cars", display: "Masini" },
  { path: "/contact", display: "Contact" },
];

const partnerLogos = [
  { src: BT, alt: "BT" },
  { src: Credius, alt: "Credius" },
  { src: Mogo, alt: "Mogo" },
  { src: TBI, alt: "TBI" },
];

const Header = () => {
  const menuRef = useRef(null);

  const toggleMenu = () => menuRef.current?.classList.toggle("menu__active");
  const closeMenu = () => menuRef.current?.classList.remove("menu__active");

  return (
    <header className="header">
      <div className="header__top">
        <Container>
          <div className="header__top-content">
            <span className="header__top__help">
              <i className="ri-phone-fill" aria-hidden="true"></i>
              <a href="tel:+40741383836">0741.383.836</a>
            </span>
            <span className="header__top__help">
              <i className="ri-map-pin-line" aria-hidden="true"></i>
              <span>Arad, Buteni, Str. Orizontului</span>
            </span>
            <span className="header__top__help">
              <i className="ri-time-line" aria-hidden="true"></i>
              <span>Luni - Duminică · 09:00 - 20:00</span>
            </span>
          </div>
        </Container>
      </div>

      <div className="header__middle">
        <Container>
          <Row className="align-items-center g-3">
            <Col lg="3" md="6" sm="12">
              <div className="logo">
                <h1>
                  <Link to="/home" className="d-flex align-items-center gap-2">
                    <img src={AutomatRulate} alt="Automat Rulate" className="logo-image" />
                    <span>Cumpara o masina cu incredere!</span>
                  </Link>
                </h1>
              </div>
            </Col>

            {partnerLogos.map((partner) => (
              <Col lg="1" md="3" sm="4" key={partner.alt} className="partner-logo-col">
                <div className="partner-logo">
                  <img src={partner.src} alt={partner.alt} className="logo-image partner-image" />
                </div>
              </Col>
            ))}

            <Col lg="2" md="6" sm="12">
              <div className="header__location d-flex align-items-center gap-1">
                <span>
                  <i className="ri-earth-line" aria-hidden="true"></i>
                </span>
                <div className="header__location-content">
                  <h4>Arad, Buteni</h4>
                  <h6>Str. Orizontului</h6>
                </div>
              </div>
            </Col>

            <Col lg="2" md="6" sm="12">
              <div className="header__location d-flex align-items-center gap-2">
                <span>
                  <i className="ri-time-line" aria-hidden="true"></i>
                </span>
                <div className="header__location-content">
                  <h4>Luni - duminica</h4>
                  <h6>09:00 - 20:00</h6>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      <div className="main__navbar">
        <Container>
          <div className="navigation__wrapper d-flex align-items-center justify-content-between">
            <button type="button" className="mobile__menu" onClick={toggleMenu} aria-label="Deschide meniul">
              <i className="ri-menu-line" aria-hidden="true"></i>
            </button>

            <div className="navigation" ref={menuRef}>
              <div className="menu">
                {navLinks.map((item) => (
                  <NavLink
                    to={item.path}
                    className={({ isActive }) => (isActive ? "nav__active nav__item" : "nav__item")}
                    key={item.path}
                    onClick={closeMenu}
                  >
                    {item.display}
                  </NavLink>
                ))}

                <div className="header__top__left">
                  <span className="header__top__help">
                    <i className="ri-phone-fill" aria-hidden="true"></i>
                    <a href="tel:+40741383836">0741.383.836</a>
                  </span>
                </div>
              </div>
            </div>

            <div className="nav__right">
              <div className="search__box">
                <input type="text" placeholder="Cauta" aria-label="Caută" />
                <span>
                  <i className="ri-search-line" aria-hidden="true"></i>
                </span>
              </div>
            </div>
          </div>
        </Container>
      </div>
    </header>
  );
};

export default Header;
